import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

export async function fetchStockIssueList(listQuery) {
  const { data: raw } = await request.get('/ims/stock-issue', {
    params: listQueryToApiParams(listQuery),
  });
  return parseVer4ListResponse(raw);
}
